// Contenuti realistici (placeholder) per APT 1968 - Polisportiva Tricesimo
import logoImg from "../assets/logo.jpg";
import atleticaImg from "../assets/atletica.webp";

export const LOGO = logoImg;

export const SOCIETA_LINKS = [
  { to: "/la-storia", label: "La Storia" },
  { to: "/consiglio-direttivo", label: "Il Consiglio Direttivo" },
  { to: "/atletica", label: "Atletica" },
  { to: "/adempimenti-124-2017", label: "Adempimenti L. 124/2017" },
];

export const NAV_LINKS = [
  { type: "scroll", id: "chi-siamo", label: "Chi Siamo" },
  { type: "dropdown", label: "La Società", items: SOCIETA_LINKS },
  { type: "scroll", id: "squadre", label: "Le Squadre" },
  { type: "scroll", id: "minibasket", label: "Minibasket" },
  { type: "scroll", id: "iscriversi", label: "Iscriviti" },
  { type: "scroll", id: "contatti", label: "Contatti" },
];

export const CONSIGLIO = {
  period: "2025 - 2027",
  members: [
    { name: "Miguel Velasco", role: "Presidente" },
    { name: "Adriano Zanchetta", role: "Vicepresidente vicario" },
    { name: "Giuseppe Cruder", role: "Vicepresidente" },
    { name: "Enrico Beltrame", role: "Consigliere" },
    { name: "Leonardo Cascino", role: "Consigliere" },
    { name: "Valter Condolo", role: "Consigliere" },
    { name: "Massimo Della Vedova", role: "Consigliere" },
    { name: "Annamaria Magro", role: "Consigliere" },
    { name: "Filippo Pellegrino", role: "Consigliere" },
    { name: "Antonio Soloperto", role: "Consigliere" },
    { name: "Gualtiero Bertacche", role: "Presidente Onorario" },
  ],
  presidenti: [
    "Manfredi Molinaro", "Enrico De Paoli", "Ivo Bertossio", "Giosuè Gobessi",
    "Giulio Sant", "Giuseppe Cruder", "Gianni Patriarca", "Nevio Merlino",
    "Gualtiero Bertacche", "Adriano Zanchetta", "Miguel Velasco",
  ],
};

export const ADEMPIMENTI = {
  intro: "Ai sensi della L. 124/2017 si comunicano le informazioni relative a sovvenzioni, sussidi, vantaggi, contributi o aiuti, in denaro o in natura, non aventi carattere generale e privi di natura corrispettiva, retributiva o risarcitoria, erogati dalle Pubbliche Amministrazioni per una somma non inferiore a Euro 10.000,00.",
  entries: [
    { period: "Anno 2020 - Anno 2021", entity: "CONI FVG", causale: "Contributi sanificazione", amount: "€ 17.000,00" },
    { period: "Anno 2022 - Anno 2023", entity: "Comune di Tricesimo", causale: "Contributo ordinario", amount: "€ 13.500,00" },
    { period: "Anno 2024", entity: "Comune di Tricesimo", causale: "Contributo ordinario", amount: "€ 13.500,00" },
    { period: "Anno 2025", entity: "Comune di Tricesimo", causale: "Contributo ordinario", amount: "€ 13.500,00" },
    { period: "Anno 2026", entity: "Comune di Tricesimo", causale: "Contributo ordinario", amount: "€ 13.500,00" },
  ],
};

export const STATS = [
  { value: "1968", label: "Anno di fondazione" },
  { value: "190+", label: "Atleti tesserati" },
  { value: "12", label: "Gruppi attivi" },
  { value: "15", label: "Allenatori qualificati" },
];

export const CHI_SIAMO = {
  kicker: "Chi Siamo",
  title: "Una famiglia di canestri nel cuore del Friuli",
  paragraphs: [
    "L'Associazione Polisportiva Dilettantistica Tricesimo nasce il 26 ottobre 1968 con il nome di \"Unione Sportiva Pallacanestro Tricesimo\" per volontà di un gruppo di \"pionieri\" amanti di quello che all'epoca era uno sport poco praticato in Italia.",
    "Nel corso degli anni sono state promosse anche altre discipline, quali: calcio, tennis tavolo, pallavolo e atletica leggera.",
    "Oggi le nostre proposte sportive si concentrano solo sulla pallacanestro e -in via residuale- sull'atletica: in ogni stagione agonistica contiamo mediamente su poco meno di 200 atleti impegnati nei campionati di categoria.",
  ],
  values: [
    { t: "Passione", d: "Lo sport come stile di vita" },
    { t: "Crescita", d: "Percorsi tecnici curati per ogni fascia d'età." },
    { t: "Comunità", d: "Radicati a Tricesimo e dintorni dal 1968." },
  ],
};

export const STORIA = [
  { year: "1968", title: "Nasce l'Unione Pallacanestro Tricesimo", text: "Prende vita l'Unione Pallacanestro Tricesimo: un pallone, un gruppo di appassionati e il sogno di portare il basket in paese." },
  { year: "1971", title: "Nasce la Polisportiva e il minibasket", text: "La società diventa Associazione Polisportiva Tricesimo e prende il via la prima leva di minibasket dedicata ai più piccoli." },
  { year: "1978", title: "Avvio del settore atletica leggera", text: "Nasce il settore di atletica leggera; l'anno successivo va in scena il primo \"Cross delle Colline Moreniche\"." },
  { year: "1983", title: "Il primo Trofeo Patrick", text: "Prende vita il Trofeo Patrick, manifestazione che negli anni diventerà un appuntamento identitario della Polisportiva." },
  { year: "1985", title: "Serie D nazionale e nuovo palazzetto", text: "La prima squadra maschile conquista la Serie D nazionale; nello stesso anno viene inaugurato il nuovo Palazzetto dello Sport di Tricesimo." },
  { year: "1988", title: "Le donne in Serie C nazionale", text: "La prima squadra femminile conquista l'accesso alla Serie C nazionale, una pagina d'orgoglio per tutta la società." },
  { year: "2006", title: "Promozione in Serie C2", text: "La prima squadra maschile conquista la promozione in Serie C2." },
  { year: "2014", title: "Di nuovo in Serie D", text: "La prima squadra maschile torna a conquistare la Serie D." },
  { year: "2015", title: "Vittoria al Trofeo Patrick", text: "Arriva la prima vittoria della Polisportiva al Trofeo Patrick." },
  { year: "2023", title: "Conquista della Divisione Regionale 1", text: "La prima squadra maschile conquista la Divisione Regionale 1 (ex Serie D)." },
];

export const SQUADRE = [
  { cat: "DR1", name: "Prima Squadra", league: "Campionato regionale", desc: "Il fiore all'occhiello: agonismo e cuore biancoblù." },
  { cat: "DR3", name: "Squadra \"Vintage\"", league: "Campionato Regionale", desc: "Un nucleo storico di tricesimani: vittorie ed esperienza" },
  { cat: "DR3", name: "Squadra \"Giovani\"", league: "Campionato Regionale", desc: "I giovani del vivaio alla prima esperienza nel basket senior: talento e ricerca della maturità." },
  { cat: "U17", name: "Under 17", league: "Campionato Provinciale", desc: "Ritmo, intensità e crescita atletica al massimo livello." },
  { cat: "U15", name: "Under 15", league: "Campionato Provinciale", desc: "Fondamentali avanzati e prime grandi sfide di squadra." },
  { cat: "ESO", name: "Esordienti", league: "Esordienti", desc: "Un ponte tra minibasket e giovanili: entusiasmo e divertimento." },
];

export const MINIBASKET = {
  kicker: "Il Minibasket",
  title: "Dove tutto ha inizio",
  text: "Il minibasket è pensato per i bambini dai 5 agli 11 anni. Attraverso il gioco insegniamo i fondamentali, la coordinazione e soprattutto il piacere di stare insieme in campo.",
  points: [
    { t: "Pulcini", d: "5-6 anni · avviamento motorio" },
    { t: "Scoiattoli", d: "7-8 anni · primi fondamentali" },
    { t: "Aquilotti", d: "9-10 anni · gioco e mini-partite" },
    { t: "Esordienti", d: "10-11 anni · primi passi verso il basket giovanile" },
  ],
  cta: "Ogni allenamento è una festa: sorrisi, canestri e nuove amicizie garantite.",
};

export const ATLETICA = {
  kicker: "Atletica Leggera",
  title: "La Storia del Cross delle Colline Moreniche",
  image: atleticaImg,
  intro: [
    "In mancanza di un settore dedicato e di impianti adeguati, l'impegno della Polisportiva nell'atletica leggera si concentra sulla realizzazione del Cross delle Colline Moreniche, una delle tappe \"storiche\" nel circuito CSI - FIDAL.",
    "Non si può raccontare la nascita del nostro storico Cross delle Colline Moreniche senza fare un passo indietro nel tempo, per ricordare come ha preso vita il settore dell'atletica leggera in seno alla Polisportiva Tricesimo. Una storia nata dal sogno, dall'intraprendenza e dal cuore del suo fondatore: Gianluigi Di Giusto, per tutti semplicemente \"Vigj\".",
  ],
  chapters: [
    {
      title: "Le origini: dal basket alla corsa (1972 - 1978)",
      paragraphs: [
        "Tutto ha inizio alla fine di agosto del 1972. Vigj, seduto sul muretto del \"marcjat\" di Tricesimo, osservava i suoi coetanei (classe 1957/58) allenarsi sul campo da basket. Invitato a scendere in campo per fare una prova, inizia così la sua avventura come cestista della Polisportiva.",
        "La svolta per l'atletica arriva cinque anni più tardi. Nel 1977, durante il soggiorno estivo della Polisportiva a Prato Carnico (promosso dal CSI provinciale), Vigj entra in contatto con diversi dirigenti dell'atletica leggera. Poco dopo, partecipa a Udine alla fase nazionale CSI.",
        "Entusiasta di queste esperienze, Vigj propone al Consiglio Direttivo della Polisportiva di fondare una sezione dedicata alla corsa. Incassato il parere favorevole a novembre, nel gennaio 1978 l'atletica leggera della Polisportiva Tricesimo fa il suo esordio ufficiale nel circuito CSI di corsa campestre, guidata dallo stesso Vigj.",
        "All'inizio i pionieri di questa disciplina sono i ragazzi del basket, che usano la corsa come preparazione atletica o per trovare spazio quando non giocano in campionato. Si correva senza grandi allenamenti mirati, ma con immensa passione.",
      ],
    },
    {
      title: "Da Monastetto a Colleombroso: nasce il \"Cross\"",
      paragraphs: [
        "Nel febbraio del 1978, la Polisportiva organizza la sua prima campestre CSI a Monastetto. Il percorso si snoda attorno ai colli dietro il Belvedere, e la giornata si conclude come piace a noi: pastasciutta e premiazioni per tutti all'Asilo Parrocchiale. È l'inizio di un viaggio lungo oltre quarant'anni.",
        "Nel 1979 entra in squadra un giovane destinato a fare la storia del settore, portando la Polisportiva a successi straordinari e diventandone il motore trainante: Adriano Zanchetta, per tutti \"Zanky\".",
        "Negli anni '80 la corsa continua a Monastetto fino al 1990 quando, a causa dell'aratura della collina usata come tracciato, la Polisportiva deve trovare una nuova casa. La scelta cade su Colleombroso di Braidamatta, uno dei percorsi di campestre più suggestivi dell'intera regione. Nasce ufficialmente il \"Cross delle Colline Moreniche\", la cui macchina organizzativa passa gradualmente nelle mani di Zanky, sempre sotto l'occhio attento e la supervisione del veterano Vigj.",
        "In questi anni la manifestazione assume anche un forte valore sociale: il terzo tempo e le premiazioni si spostano alla Casa di Riposo di Tricesimo, regalando una giornata di festa, allegria e compagnia agli ospiti della struttura.",
      ],
    },
    {
      title: "L'approdo a Laipacco: il \"Cross di Lipà\"",
      paragraphs: [
        "Il 1997 segna un altro storico cambiamento, stavolta dettato dalla sinergia con il territorio. La storica Sagra di San Giuseppe di Laipacco di Tricesimo riapre i battenti dopo anni di inattività e il comitato organizzatore propone alla Polisportiva di spostare la gara nella frazione.",
        "Nasce così il \"Cross delle Colline Moreniche di Lipà\". Da allora, la tradizione si ripete identica e amatissima: dopo le fatiche della corsa ci si ritrova tutti festanti in Sagra per le premiazioni, la pastasciutta e il tipico \"doping\" locale, vera specialità della casa: us durs e lidric cul poc (uova sode e cicorietta con il sugo di ciccioli).",
      ],
    },
    {
      title: "Una macchina mossa dalla passione",
      paragraphs: [
        "Il successo straordinario che questa gara registra fin dalla sua prima edizione è il frutto di un grande lavoro di squadra. Un ringraziamento speciale e doveroso va alla fondamentale collaborazione dell'Associazione Nazionale Alpini di Tricesimo e al Comitato Festeggiamenti di San Giuseppe.",
        "Ma il grazie più grande, quello che viene dal cuore di tutta la Polisportiva, va a loro: a Vigj e Zanky. Senza la loro amicizia, la loro visione e la loro instancabile dedizione, non sarebbe stato possibile scrivere questa bellissima pagina di sport, comunità e condivisione.",
      ],
    },
  ],
  dedica: {
    title: "Nel ricordo di Patrick",
    text: "A testimonianza di come lo sport sia prima di tutto memoria e affetto, a partire dal 2025 la manifestazione è dedicata alla memoria di Patrick Aita, raccogliendo il testimone della storica staffetta podistica nata nel 1983 e disputatasi fino ad agosto 2024.",
  },
};


export const ISCRIZIONE = [
  { n: "01", t: "Vieni a provare", d: "Scrivici una email e fissa una settimana di prova gratuita con i nostri istruttori." },
  { n: "02", t: "Visita medica", d: "Presenta il certificato di idoneità sportiva per la tua fascia d'età." },
  { n: "03", t: "Tesseramento", d: "Iscriviti sul nostro gestionale \"Golee\", versa la quota e sei ufficialmente parte della Polisportiva Tricesimo." },
];

export const CONTATTI = {
  sede: "La sede è adiacente al Palazzetto dello Sport",
  address: "Via San Pelagio 17, 33019 Tricesimo (UD)",
  email: "polisportivatricesimo@gmail.com",
    socials: [
    { label: "Instagram", href: "https://www.instagram.com/polisportivatricesimo/" },
    { label: "Facebook", href: "https://www.facebook.com/aptricesimo/" },
    { label: "YouTube", href: "https://www.youtube.com/@polisportivatricesimo8535" },
  ],
};
